import { Hourglass } from 'lucide-react'
import * as m from '~/paraglide/messages'
import { Card } from '~/shared/ui/card'

export function CrosspostingUnavailable() {
  return (
    <Card className="flex flex-col items-center gap-4 p-10 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-muted text-muted-foreground">
        <Hourglass className="h-6 w-6" />
      </span>
      <div className="space-y-1.5">
        <h3 className="font-semibold tracking-tight">{m.crosspostingUnavailableTitle()}</h3>
        <p className="mx-auto max-w-md text-sm text-muted-foreground">
          {m.crosspostingUnavailableDescription()}
        </p>
      </div>
    </Card>
  )
}
